import React, { Fragment } from 'react'
import { Intro, Slideshow, slideTypes, slideTextTypes } from 'cvs-core'
import img1 from '../../assets/images/U2-T1-1-10a_R.svg'
import img2 from '../../assets/images/U2-T1-1-10b_U.svg'
import img3 from '../../assets/images/U2-T1-1-10c_L.svg'
import img4 from '../../assets/images/U2-T1-1-10d_R.svg'
import img5 from '../../assets/images/U2-T1-1-10e_R.svg'

import voAudio1 from '../../assets/vo/CVS-HS-SPM-Reflect-01-01.mp3'
import voAudio2 from '../../assets/vo/CVS-HS-SPM-Reflect-01-02.mp3'
import voAudio3 from '../../assets/vo/CVS-HS-SPM-Reflect-01-03.mp3'
import voAudio4 from '../../assets/vo/CVS-HS-SPM-Reflect-01-04.mp3'
import voAudio5 from '../../assets/vo/CVS-HS-SPM-Reflect-01-05.mp3'

const data = [
  {
    SlideType: slideTypes.HorizontalPan,
    duration: 8.5,
    panDirection: 'right',
    image: img1,
    imageAltText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Dangerous to Body and Brain',
    },
    vo: {
      sources: [
        {
          src: voAudio1,
        },
      ],
      transcript:
        'You already knew that vaping was dangerous to your body and brain, especially because your brain and body are still developing.',
    },
  },
  {
    SlideType: slideTypes.VerticalPan,
    duration: 12.5,
    panDirection: 'top',
    image: img2,
    imageAltText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Be a Critical Observer',
    },
    vo: {
      sources: [
        {
          src: voAudio2,
        },
      ],
      transcript:
        'But now you also know about some of the ways that e-cigarette companies “hook” teens on vaping, such as misleading advertisements, strategic ads, and product placement on social media.',
    },
  },
  {
    SlideType: slideTypes.HorizontalPan,
    duration: 10.5,
    panDirection: 'left',
    image: img3,
    imageAltText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Smart social media',
    },
    vo: {
      sources: [
        {
          src: voAudio3,
        },
      ],
      transcript:
        'Taking charge of your social media experience by hiding ads, unfollowing questionable influences, and updating your settings is one way to make sure you stay vape free.',
    },
  },
  {
    SlideType: slideTypes.HorizontalPan,
    duration: 13.5,
    panDirection: 'right',
    image: img4,
    imageAltText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Helpful Resources',
    },
    vo: {
      sources: [
        {
          src: voAudio4,
        },
      ],
      transcript:
        'There are also many resources to help you or a friend stop vaping if you’ve started, like text messaging programs, apps, medical professionals, and human resources like parents and teachers.',
    },
  },
  {
    SlideType: slideTypes.HorizontalPan,
    duration: 4.5,
    panDirection: 'left',
    image: img5,
    imageAltText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Be Vape Free',
    },
    vo: {
      sources: [
        {
          src: voAudio5,
        },
      ],
      transcript: 'With all this knowledge, you are empowered to be vape free!',
    },
  },
]

export default {
  title: 'Wrap Up',
  path: '/reflect/wrap-up',
  content: (
    <Fragment>
      <Intro
        title="Wrap Up"
        direction="Select the play button below to begin."
      />
      <Slideshow slides={data} />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Reflect/WrapUp.js